import { Typography } from '@material-ui/core';
import React from 'react';
import { RiPlantLine } from 'react-icons/ri';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import icon from '../images/Icons/experian.png';

const Home = () => (
  <div className='space-y-10 w-auto container mx-auto'>
    <div className='intro text-center container mx-auto pt-10 '>
      <h1
        align='center'
        className='text-6xl md:text-7xl lg:text-9xl fontbold text-transparent bg-gradient-to-br from-green-500 to-blue-600 bg-clip-text'>
        רשת דירוגים
      </h1>
      <div className='text-2xl lg:text-3xl antialiased flex flex-wrap justify-evenly sm:justify-center mt-6'>
          {/* links take you to the bottom of pages */}
        {[
          { text: ' קיימות וסביבה', icon: <HiOutlineUserGroup />, link: 'energy-efficiency' },
          { text: 'מידע ומימון', icon: <RiPlantLine />, link: 'funding' },
          { text: 'אנרגיה', icon: <AiOutlineThunderbolt className='md:text-4xl md:p-1 lg:p-px' />, link: 'energy-storage' },
        ].map((item) => (
          <div className='flex flex-nowrap justify-center w-1/4 minW mt-4 sm:mt-0'>
            <div className=' flex items-center justify-center rounded-full shadow bg-gray-50 h-10 w-10 md:h-12 md:w-12 mx-4 sm:ml-4'>
              <a href={`#${item.link}`}>{item.icon}</a>
            </div>
            <p className='my-auto '>
              <a href={`#${item.link}`}>{item.text}</a>
            </p>
          </div>
        ))}
      </div>
    </div>

    <div className='space-y-20 flex justify-evenly flex-wrap content-center'>
      {[
        {
          icon: <HiOutlineUserGroup style={{ fontSize: '7rem', marginBottom: '30px' }} />,
          title: 'קיימות וסביבה',
          text: 'מתן שירותי ייעוץ ותסקיר סביבתי וכלכלי למפעלים ומוסדות ציבור   תוך התמקדות ביעלות אנרגטית והפחתת פליטות פחמן.',
          link: 'energy-efficiency',
        },
        {
          icon: <img src={icon} alt='funding logo' style={{ height: '7rem', marginBottom: '30px' }} />,
          title: 'מידע ומימון',
          text: 'דוחות סיכון אשראי ומידע עיסקי על חברות ועסקים ברחבי העולם  מענקית המידע העולמי EXPERIAN. המומחים שלנו בגיוס מימון יגייסו עבורכם מימון למערכות אנרגיה, התייעלות אנרגטית ועוד.',
          link: 'funding',
        },
        {
          icon: <AiOutlineThunderbolt style={{ fontSize: '7rem', marginBottom: '30px' }} />,
          title: 'אנרגיה',
          text: 'מתן שירותי ייעוץ וניתוח כלכלי של פרויקטי אנרגיה. בשוק אנרגיה משוכלל הכולל מגוון רחב של מקורות ויצרני אנרגיה ובשילוב תעריפים שונים יש צורך בבדיקת כדאיות עיסקית וניתוח כלכלי לכל פרויקט. אנו מבצעים ייעוץ זה וכן את ניהול פרויקט האנרגיה עד לשלב החיבור לרשת החשמל והפעלה.',
          link: 'energy-storage',
        },
      ].map((item) => (
        <div align='center' className='mt-20 mx-6 md:mx-0' id={item.link}>
          {item.icon}
          <h3 className='text-2.5xl font-semibold mb-4'>{item.title}</h3>
          <Typography variant='h6' className='max-w-sm text-center mb-3'>
            <p className='mb-8'>{item.text}</p>
            <Link to={item.link} className='border border-black rounded px-2 py-1'>
              לעמוד המלא
            </Link>
          </Typography>
        </div>
      ))}
    </div>
  </div>
);
export default Home;
